var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6039 24.7235H16.033C15.6197 24.7235 15.209 24.6595 14.8153 24.5336L8.82386 22.6188C7.69172 22.257 6.77913 21.4104 6.33345 20.3086L4.50447 15.787C3.86166 14.1978 4.30293 12.3757 5.60158 11.2568L9.62662 7.7886C9.99642 7.46997 10.3048 7.08634 10.5364 6.65668L12.2896 3.40516C13.3635 1.41338 15.8745 0.70826 17.8283 1.8498L22.1753 4.38958C22.8455 4.78115 23.3873 5.35927 23.7346 6.05343L24.0007 6.58521C24.2389 7.06136 24.3797 7.58027 24.4148 8.11154L24.7461 13.1286L25.7844 14.4817C26.8992 15.9347 26.885 17.9591 25.7498 19.3962L22.7427 23.203C21.9842 24.1633 20.8277 24.7235 19.6039 24.7235Z",
    fill: "#E6E5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1942 5.17773C16.8202 5.17773 17.3276 5.68515 17.3276 6.31107V10.7858L19.5801 9.62715C20.1367 9.34085 20.82 9.55997 21.1063 10.1166C21.3926 10.6732 21.1735 11.3565 20.6169 11.6428L17.3276 13.3348V18.416L21.8366 16.1576C22.3963 15.8772 23.0772 16.1037 23.3575 16.6633C23.6378 17.223 23.4113 17.9039 22.8517 18.1842L17.3276 20.9511V30.3856C17.3276 31.0115 16.8202 31.5189 16.1942 31.5189C15.5683 31.5189 15.0609 31.0115 15.0609 30.3856V17.2391L10.6199 15.5381C10.0354 15.3142 9.743 14.6589 9.96689 14.0744C10.1908 13.4898 10.8461 13.1975 11.4306 13.4214L15.0609 14.8119V6.31107C15.0609 5.68515 15.5683 5.17773 16.1942 5.17773Z",
    fill: "#B1B0F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1944 4.97656C16.9308 4.97656 17.5278 5.57352 17.5278 6.3099V30.3844C17.5278 31.1208 16.9308 31.7177 16.1944 31.7177C15.458 31.7177 14.8611 31.1208 14.8611 30.3844V6.3099C14.8611 5.57352 15.458 4.97656 16.1944 4.97656Z",
    fill: "#8E8CEE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTree);
export default __webpack_public_path__ + "static/media/tree.f25a2f8f25c8e032a85786d087c1d9e3.svg";
export { ForwardRef as ReactComponent };